import { render, staticRenderFns } from "./ThemeChange.vue?vue&type=template&id=71e0e03b&scoped=true"
import script from "./ThemeChange.vue?vue&type=script&lang=js"
export * from "./ThemeChange.vue?vue&type=script&lang=js"
import style0 from "./ThemeChange.vue?vue&type=style&index=0&id=71e0e03b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e0e03b",
  null
  
)

export default component.exports